import Component from '@bythepixel/component-loader';
import Tabs from '../base';
import fadeOut from '../../../../core/utility/fadeOut';
import fadeIn from '../../../../core/utility/fadeIn';

export default class SectionTabs extends Component {
  static selector = '[data-comp-tabs]';
  constructor(containerEl) {
    super(containerEl);

    const tabContainer = this.$container;
    const tabContent = 'data-tab-content';
    const tabButton = 'data-tab-button';

    this.sectionTabs = new Tabs(this.$container, {
      childSelector: '[data-tab-button]',
      activeClass: 'section-tabs__tab-item--active',
      onSelect: (activeTab, inactiveTabs) => {
        inactiveTabs.forEach(tab => {
          fadeOut(tabContainer.querySelector(`[${tabContent}="${tab.getAttribute(tabButton)}"]`), {
            done() {
              fadeIn(tabContainer.querySelector(`[${tabContent}="${activeTab.getAttribute(tabButton)}"]`));
            },
          });
        });
      },
    });
  }
}
